export default "__VITE_ASSET__BXimwhOf__"